import { useMsal } from "@azure/msal-react";

import { ButtonSmall } from "@anwb/poncho/components/button";
import Grid from "@anwb/poncho/components/grid";

function Login() {
  const { instance } = useMsal();

  return (
    <Grid>
      <Grid.Item>
        <ButtonSmall
          color="tertiary"
          onClick={() => {
            instance.loginRedirect().catch((error) => {
              console.error("Login redirect failed:", error);
            });
          }}
        >
          Login using Azure AD
        </ButtonSmall>
      </Grid.Item>
    </Grid>
  );
}

export default Login;
